import { readToken } from "./authState";

/** 분류 결과 공유(2026-10-06) — 서버 /api/onto/share. */
async function call(path, { method = "GET", body = null, auth = true, fetchImpl = fetch } = {}) {
  const headers = { "Content-Type": "application/json" };
  const token = auth ? readToken() : null;
  if (token) headers.Authorization = `Bearer ${token}`;
  const r = await fetchImpl(`/api/onto/share${path}`, { method, headers, body: body ? JSON.stringify(body) : undefined });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) {
    const e = new Error(j.error || `오류 ${r.status}`);
    e.status = r.status;
    throw e;
  }
  return j;
}

export const createShare = (payload, fetchImpl) => call("", { method: "POST", body: payload, fetchImpl });
export const getShare = (token, fetchImpl) => call(`/${encodeURIComponent(token)}`, { auth: false, fetchImpl });
export const myShares = (fetchImpl) => call("/mine", { fetchImpl });
export const updateShare = (token, payload, fetchImpl) => call(`/${encodeURIComponent(token)}/update`, { method: "POST", body: payload, fetchImpl });
export const revokeShare = (token, fetchImpl) => call(`/${encodeURIComponent(token)}/revoke`, { method: "POST", fetchImpl });
export const emailShare = (token, to, message, fetchImpl) => call(`/${encodeURIComponent(token)}/email`, { method: "POST", body: { to, message }, fetchImpl });

/** 주소 /s/토큰 → 토큰(없으면 null) */
export function shareTokenFromPath(pathname = window.location.pathname) {
  const m = String(pathname || "").match(/^\/s\/([A-Za-z0-9]{8,16})\/?$/);
  return m ? m[1] : null;
}

export function formatCode(code) {
  const d = String(code || "").replace(/\D/g, "");
  if (d.length === 10) return `${d.slice(0, 4)}.${d.slice(4, 6)}-${d.slice(6)}`;
  if (d.length === 6) return `${d.slice(0, 4)}.${d.slice(4)}`;
  return d;
}
